import { FederatedModule } from '@zenbusiness/application-commons-federation';
import PageError from '@zenbusiness/zui/PageError';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { FEDERATED } from '#client/build-env';

const fedProps = {
  loadingElement: <PageLoading />,
  errorElement: <PageError />
};

export function AppTemplateUi(props) {
  return (
    <FederatedModule
      {...fedProps}
      {...FEDERATED.AppTemplateUi}
      {...props}
    />
  );
}

export function AssistantUi(props) {
  return (
    <FederatedModule
      {...fedProps}
      {...FEDERATED.AssistantUi}
      {...props}
    />
  );
}

export function BankingUi(props) {
  return (
    <FederatedModule
      {...fedProps}
      {...FEDERATED.bankingUI}
      exportName="FederatedAppV2"
      {...props}
    />
  );
}

export function ComplianceUi(props) {
  return (
    <FederatedModule
      {...fedProps}
      {...FEDERATED.ComplianceUi}
      {...props}
    />
  );
}

export function DocumentsUi(props) {
  return (
    <FederatedModule
      {...fedProps}
      {...FEDERATED.DocumentsUi}
      {...props}
    />
  );
}

export function EcommServicesUi(props) {
  return (
    <FederatedModule
      {...fedProps}
      {...FEDERATED.EcommServicesUi}
      {...props}
    />
  );
}

export function EcommerceUi(props) {
  return (
    <FederatedModule
      {...fedProps}
      {...FEDERATED.EcommerceUi}
      {...props}
    />
  );
}

export function InvoicingUi(props) {
  return (
    <FederatedModule
      {...fedProps}
      {...FEDERATED.InvoicingUi}
      {...props}
    />
  );
}

export function MoneyUi(props) {
  return (
    <FederatedModule
      {...fedProps}
      {...FEDERATED.MoneyUi}
      exportName="Money"
      {...props}
    />
  );
}

export function WebsitesUi(props) {
  return (
    <FederatedModule
      {...fedProps}
      {...FEDERATED.WebsitesUi}
      {...props}
    />
  );
}
